import React from 'react';
import './MobileLoader.css'

interface PropData {
  show: boolean;
  message?: string;
}

const MobileLoader = (props: PropData) => {
  return (
    <>
      {props.show && (
        <div className="resultLoading">
          <div className="bg"></div>

          <div className="loader-container">
            <div className="spinner"></div>
            <div className="loader-text">
              {props.message ? props.message : 'Loading...'}
            </div>
          </div>

        </div>
      )}
    </>
  )
}

export default MobileLoader;